var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinContact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 20C39.5 30.7695 30.7695 39.5 20 39.5C9.23045 39.5 0.5 30.7695 0.5 20C0.5 9.23044 9.23044 0.5 20 0.5C30.7695 0.5 39.5 9.23044 39.5 20Z",
    stroke: "#232123"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4865 15.8168H14.9249V25.8629H12.4865V15.8168ZM13.7061 10.3281C14.5295 10.3281 15.1968 10.9965 15.1968 11.8172C15.1968 12.6403 14.5287 13.3095 13.7061 13.3095C12.8799 13.3095 12.2129 12.64 12.2129 11.8172C12.2129 10.9969 12.8798 10.3281 13.7061 10.3281Z",
    fill: "#232123",
    stroke: "#232123"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0791 15.8166H20.3723V16.8272V17.3272H20.8723H20.9176H21.219L21.3598 17.0607C21.7361 16.3478 22.6907 15.543 24.1688 15.543C25.7839 15.543 26.6281 16.0633 27.1081 16.8246C27.6215 17.6388 27.7862 18.8275 27.7862 20.3042V25.8627H25.3553V20.9924V20.9916C25.3553 20.3724 25.3553 19.5396 25.0878 18.8631C24.9483 18.5103 24.7276 18.1748 24.3783 17.9308C24.0279 17.6861 23.5908 17.5634 23.0711 17.5634C22.5592 17.5634 22.1195 17.6636 21.7529 17.8666C21.3835 18.0712 21.1183 18.3638 20.9331 18.7C20.5757 19.3486 20.5116 20.1701 20.5116 20.8992V25.8627H18.0799L18.0791 15.8166Z",
    fill: "#232123",
    stroke: "#232123"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinContact);
export default __webpack_public_path__ + "static/media/linkedinContact.d22788f878bd87077483314e4daa7780.svg";
export { ForwardRef as ReactComponent };